import React, { useState, useMemo, createContext } from "react";
import { Auth, Hub } from "aws-amplify";
import { DEV_USER_ID } from "../constant";

const AuthContext = createContext();
const ZAuth = (props) => {
  const [user, setUser] = useState(null);
  const logout = () => {
    if (DEV_USER_ID) {
      localStorage.clear();
      setUser(undefined);
      return;
    }
    Auth.signOut();
    localStorage.clear();
  };

  const authMemo = useMemo(() => ({ user, logout }), [user]);
  const init = async () => {
    if (DEV_USER_ID) {
      setUser({
        username: DEV_USER_ID,
        name: "Dev User",
        email: "dev@local",
      });
      return;
    }
    try {
      const u = await Auth.currentAuthenticatedUser();
      const username = u.username;
      const name = u.name;
      const email = u.attributes.email;
      setUser({ username, name, email });
    } catch (err) {
      setUser(undefined);
    }
  };

  const listen = () => {
    if (DEV_USER_ID) return;
    Hub.listen("auth", ({ payload: { event } }) => {
      switch (event) {
        case "signIn":
        case "tokenRefresh":
          // Re-pull the user record so custom-login pages get into
          // the protected app immediately after Auth.signIn.
          init();
          break;
        case "signOut":
          setUser(undefined);
          break;
      }
    });
  };

  React.useEffect(() => {
    init();
    listen();
  }, []);

  return (
    <AuthContext.Provider value={authMemo}>
      {props.children}
    </AuthContext.Provider>
  );
};

export { ZAuth, AuthContext };
